export const LiquidityDistribution = () => {
  return (
    <div>
      <div className="liquidity-left">
        <h6>Distributed amongst</h6>
        <p className="text-primary">{278} Liquidity Providers</p>
      </div>
      <div className="liquidity-right">
        <h6 className="text-secondary">Reserved for</h6>
        <p className="text-secondary">{3620} Pending Bets</p>
      </div>
    </div>
  );
};
